/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Стандартный объект ошибки
 */
export interface DefaultExceptionResponse {
  /**
   * Тип проблемы. Внутренний тип ошибки микросервиса Сотрудники
   * @example A5478
   */
  type?: string;

  /**
   * Описание логической ошибки, возникшей в процессе работы
   * @example Некорректный формат идентификатора ресурса
   */
  title?: string;

  /**
   * Код состояния HTTP ( [RFC7231], раздел 6 ) созданный исходным сервером
   * @format int32
   * @example 400
   */
  status?: number;

  /**
   * Удобочитаемое объяснение проблемы
   * @example Сотрудник 9146590 не найден
   */
  detail?: string;
}

/**
 * Запрос на увольнение
 */
export interface DismissEmployeeRequest {
  /**
   * Идентификатор клиента (ЮЛ) в АБС ЦФТ
   * @example 9894250
   */
  clientId: string;

  /**
   * Идентификатор договора ЗП в АБС ЦФТ
   * @example 612960762736
   */
  contractId: string;

  /**
   * Номер зарплатного договора
   * @example 223500-4472
   */
  contractNumber?: string;

  /**
   * Идентификатор сотрудника (ФЛ) в АБС ЦФТ
   * @example Пользователь_99190
   */
  employeeId: string;

  /**
   * Дата увольнения сотрудника
   * @example "2022-11-22T00:00:00.000Z"
   */
  dismissDate: string;

  /**
   * Тарифный план сотрудника
   * @example Персональный
   */
  tariffPlan?: string;

  /**
   * Наименование банка
   * @example РОССЕЛЬХОЗБАНК
   */
  bankName?: string;

  /**
   * БИК банка
   * @example 044030910
   */
  bankBIC?: string;

  /**
   * ИНН банка
   * @example 7725114488
   */
  bankINN?: string;

  /**
   * Причина увольнения
   * @example Комментарий
   */
  comment?: string;
}

/**
 * Информация об адресе
 */
export interface AddressInfo {
  /** Тип населенного пункта */
  type?: string;

  /** Регион, район */
  region?: string;

  /**
   * Населенный пункт
   * @example Простоквашино
   */
  city?: string;

  /**
   * Улица
   * @example Ленина
   */
  street?: string;

  /**
   * Дом
   * @example 2
   */
  house?: string;

  /**
   * Квартира
   * @example 10
   */
  apartment?: string;

  /**
   * Индекс
   * @example 111000
   */
  index?: string;

  /**
   * Тип улицы
   * @example б-р
   */
  streetType?: string;
}

/**
 * Информация о банковской карте
 */
export interface CardInfo {
  /**
   * Тип карты
   * @example Классическая карта МИР
   */
  type?: string;

  /**
   * транслитерация
   * @example null
   */
  latin?: string;

  /**
   * Кодовое слово
   * @example Иванова1234
   */
  phrase?: string;
}

/**
 * Контактная информация
 */
export interface ContactInfo {
  /**
   * Информация по карте
   * @example ivanovPES@mail.ru
   */
  email?: string;

  /**
   * Чек-бокс "СМС-информирование"
   * @example true
   */
  smsInfo?: boolean;

  /**
   * мобильный телефон сотрудника
   * @example +7 999 123 45 67
   */
  tel?: string;

  /**
   * домашний телефон сотрудника
   * @example +7 999 123 45 67
   */
  telHome?: string;

  /**
   * рабочий  телефон сотрудника
   * @example +7 999 123 45 67
   */
  telWork?: string;
}

/**
 * Информация о сотруднике для включения в реестр ЗП
 */
export interface DetailedEmployeeInfo {
  /**
   * Имя сотрудника
   * @example ТАТЬЯНА
   */
  firstName?: string;

  /**
   * Фамилия сотрудника
   * @example СТАХЕЕВА
   */
  lastName?: string;

  /**
   * Отчество сотрудника
   * @example РАФАИЛОВНА
   */
  patronymic?: string;

  /**
   * Дата рождения сотрудника
   * @example 21.12.1999T00:00:00
   */
  dateBirth?: string;

  /**
   * ID реестра
   * @example 9108621
   */
  registryId?: string;

  /**
   * ID клиента (ЮЛ)
   * @example 9017206
   */
  clientId?: string;

  /** ID договора ЗП */
  contractId?: string;

  /**
   * ID сотрудника
   * @example 9146590
   */
  employeeId?: string;

  /** Место рождения сотрудника */
  bplPlace?: string;

  /**
   * Идентификатор страны рождения сотрудника из справочника стран "https://dev-ikul.rshb.ru/ib6_new/rest-front/v2/dict/country"
   * @example 28945
   */
  bplCountryCode?: string;

  /**
   * Идентификатор страны, гражданство которое у клиента юрика из справочника стран "https://dev-ikul.rshb.ru/ib6_new/rest-front/v2/dict/country"
   * @example 102828
   */
  countryNumericCode?: string;

  /**
   * Пол сотрудника
   * @pattern ^(SEX01|SEX02)$
   * @example SEX01
   */
  sexValue?: string;

  /** Информация о документе удостоверяющим личность (ДУЛ) */
  identityDoc?: IdentityDocumentInfo;

  /** Информация об адресе */
  addressReg?: AddressInfo;

  /** Информация об адресе */
  addressFact?: AddressInfo;

  /** Информация о банковской карте */
  card?: CardInfo;

  /**
   * ИНН
   * @example 7703 45613278
   */
  inn?: string;

  /**
   * Полис ОМС
   * @example 1234 5678 9012 3456
   */
  oms?: string;

  /**
   * СНИЛС
   * @example 132-456-786 09
   */
  snils?: string;

  /**
   * Табельный номер сотрудника
   * @example 0123
   */
  tabel?: string;
  residenceTypes?: string;
  taxResidentOfForeignJurisdiction?: boolean;

  /** Контактная информация */
  contactInfo?: ContactInfo;

  /** Информация о миграционном документе */
  migrationDoc?: MigrationDocument;
}

/**
 * Информация о документе удостоверяющим личность (ДУЛ)
 */
export interface IdentityDocumentInfo {
  /**
   * Дата выдачи ДУЛ
   * @example 21.12.1999T00:00:00
   */
  date?: string;

  /**
   * Дата окончания ДУЛ
   * @example 21.12.2024T00:00:00
   */
  dateend?: string;

  /**
   * Серия ДУЛ
   * @example 6504
   */
  series?: string;

  /**
   * Номер ДУЛ
   * @example 123456
   */
  number?: string;

  /** Тип документа из справочника "https://dev-ikul.rshb.ru/ib6_new/rest-front/v2/dict/identityDocType?processCode=WAGE" */
  type?: string;

  /**
   * Кем выдан
   * @example УФМС МО
   */
  unit?: string;

  /**
   * Код подразделения
   * @example 661-003
   */
  unitcode?: string;
}

/**
 * Информация о миграционном документе
 */
export interface MigrationDocument {
  /** Тип миграционного документа */
  type?: string;

  /** серия миграционной документа */
  series?: string;

  /** номер миграционной документа */
  number?: string;

  /**
   * дата выдачи миграционного документа
   * @example 21.12.2021T00:00:00
   */
  beginDate?: string;

  /**
   * дата окончания миграционного документа
   * @example 21.12.2026T00:00:00
   */
  endDate?: string;
  gringo?: string;

  /** страна миграционного документа */
  country?: string;

  /** ТИН (Идентификационный номер налогоплательщика (TIN) представляет собой идентификационный номер, используемый Налоговым управлением США при администрировании соблюдения налогового законодательства. Этот номер выдается Администрацией социального обеспечения (SSA) или Налоговым управление США (IRS)) */
  tin?: string;

  /** причина отсутствия ТИН */
  reasonForNotHavingTin?: string;

  /** номер миграционной карты */
  mCardNumber?: string;

  /** серия миграционной карты */
  mCardSeries?: string;
}

/**
 * Информация о сотруднике для включения в реестр ЗП
 */
export interface ContractEmployeeInfo {
  /**
   * Имя сотрудника
   * @example ТАТЬЯНА
   */
  firstName?: string;

  /**
   * Фамилия сотрудника
   * @example СТАХЕЕВА
   */
  lastName?: string;

  /**
   * Отчество сотрудника
   * @example РАФАИЛОВНА
   */
  patronymic?: string;

  /**
   * Дата рождения сотрудника
   * @example 21.12.1999T00:00:00
   */
  dateBirth?: string;

  /**
   * ID реестра
   * @example ListEmployee
   */
  entityKind?: string;

  /**
   * ID клиента (ЮЛ)
   * @example 3772679
   */
  clientId?: string;

  /**
   * ID договора ЗП
   * @example 223500-3987
   */
  contractId?: string;

  /**
   * ID сотрудника
   * @example 123456789
   */
  employeeId?: string;

  /**
   * @format int32
   * @example 1
   */
  employeeCount?: number;

  /** Информация о документе удостоверяющим личность (ДУЛ) */
  identityDocument?: IdentityDocumentShort;
  residenceTypes?: boolean;

  /**
   * Номер телефона сотрудника
   * @example 79097876169
   */
  tel?: string;

  /**
   * Номер счета сотрудника
   * @example 40817810135330001504
   */
  account?: string;
}

/**
 * Список сотрудников
 */
export interface ContractEmployeeInfoSliceResponse {
  data?: ContractEmployeeInfo[];
  hasMore?: boolean;

  /** @format int32 */
  lastUpdate?: number;
}

/**
 * Информация о документе удостоверяющим личность (ДУЛ)
 */
export interface IdentityDocumentShort {
  /**
   * Серия ДУЛ
   * @example 4546
   */
  series?: string;

  /**
   * Номер ДУЛ
   * @example 123456
   */
  number?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Зарплатный проект. Микросервис Сотрудники
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-salary-employees.ndbo.dev.rshbdev.ru
 * @contact https://sdlc.go.rshbank.ru/jira/projects/OB_WAGE <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=85998056)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Получение ответа на запрос данных по зарплатному договору из ЦФТ
     *
     * @tags Интеграция с АБС ЦФТ
     * @name SendInformationClientWageResp
     * @summary Receiver for SendInformationClientWageResp
     * @request POST:/api/salary-employees/service/v1/abs-cft/response
     */
    sendInformationClientWageResp: (data: string, params: RequestParams = {}) =>
      this.request<void, DefaultExceptionResponse>({
        path: `/api/salary-employees/service/v1/abs-cft/response`,
        method: "POST",
        body: data,
        ...params,
      }),

    /**
     * @description Выгрузка данных о сотрудниках в Excel-файл
     *
     * @tags Сотрудники
     * @name DownloadXlsx
     * @summary Download employees info in xlsx-file
     * @request POST:/api/salary-employees/external/v1/export-employee-list-xlsx
     */
    downloadXlsx: (data: string[], params: RequestParams = {}) =>
      this.request<File, DefaultExceptionResponse>({
        path: `/api/salary-employees/external/v1/export-employee-list-xlsx`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Уволить сотрудника (исключить из зарплатного договора)
     *
     * @tags Сотрудники
     * @name DismissEmployee
     * @summary Dismiss employee
     * @request POST:/api/salary-employees/external/v1/dismiss-employee
     */
    dismissEmployee: (
      data: DismissEmployeeRequest,
      params: RequestParams = {}
    ) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-employees/external/v1/dismiss-employee`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Получение информации по конкретной записи о счете сотрудника
     *
     * @tags Сотрудники
     * @name GetEmployeeInfo
     * @summary Get employee info by local ID
     * @request GET:/api/salary-employees/external/v1/employee/{employeeId}
     */
    getEmployeeInfo: (
      employeeId: string,
      query?: { clientId?: string; registerId?: string },
      params: RequestParams = {}
    ) =>
      this.request<DetailedEmployeeInfo, DefaultExceptionResponse>({
        path: `/api/salary-employees/external/v1/employee/${employeeId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Поиск сотрудников по ФИО и дате открытия счета в рамках зарплатного договора
     *
     * @tags Сотрудники
     * @name GetEmployees
     * @summary Search employees by contract, initials and account date
     * @request GET:/api/salary-employees/external/v1/client/{clientId}/contract/{contractId}/employees
     */
    getEmployees: (
      clientId: string,
      contractId: string,
      query?: {
        position?: number;
        size?: number;
        beginDate?: string;
        endDate?: string;
        searchText?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ContractEmployeeInfoSliceResponse, DefaultExceptionResponse>(
        {
          path: `/api/salary-employees/external/v1/client/${clientId}/contract/${contractId}/employees`,
          method: "GET",
          query: query,
          format: "json",
          ...params,
        }
      ),

    /**
     * @description Получение количства сотрудников по зарплатному договору
     *
     * @tags Сотрудники
     * @name GetEmployeesCountByContract
     * @summary Get employees count in contract
     * @request GET:/api/salary-employees/external/v1/client/{clientId}/contract/{contractId}/employees-count
     */
    getEmployeesCountByContract: (
      clientId: string,
      contractId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-employees/external/v1/client/${clientId}/contract/${contractId}/employees-count`,
        method: "GET",
        ...params,
      }),
  };
}

export const api = new Api();
